import { useCallback } from 'react';

import { PlansProduct, SubscribePlan } from '../../../../types';
import { OnetimePeriod, PlanTemplateType, SubscriptionPeriod } from '../types';
import { filterPlanProducts } from '../utils';

/**
 *  선택한 플랜의 정보를 제공하는 hook
 */
export const useSelectedPlanInfo = ({
  planTemplateType,
  subscriptionPeriod,
  onetimePeriod,
}: {
  planTemplateType: PlanTemplateType;
  subscriptionPeriod?: SubscriptionPeriod;
  onetimePeriod?: OnetimePeriod;
}) => {
  return useCallback(
    ({
      plans,
      planType,
      maxCcu,
    }: {
      plans: PlansProduct;
      planType: Omit<SubscribePlan, 'free'>;
      maxCcu: number;
    }) => {
      const key = planType === 'pro' ? 'PRO' : 'BASIC';

      const planProducts = plans[key];

      const planProduct = filterPlanProducts({
        plans: planProducts,
        planTemplateType,
        maxCcu,
        subscriptionPeriod,
        onetimePeriod,
      });

      // 없을 경우 첫 번째 플랜 프로덕트 상품으로 대체
      return planProduct || { ...planProducts[0] };
    },
    [planTemplateType, subscriptionPeriod, onetimePeriod],
  );
};
